import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Award, Building2, Mail, Lock, Phone } from 'lucide-react';
import Footer from '../../components/common/Footer';
import '../../components/common/Footer.css';
import './Auth.css';

export default function RegisterPage() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await register(form.name, form.email, form.password, form.phone);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'שגיאה בהרשמה');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <Award size={32} />
          <h1>אישורי לימודים</h1>
        </div>
        <p className="auth-subtitle">הרשמת מוסד חדש</p>
        {error && <div className="auth-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="label"><Building2 size={14} /> שם המוסד</label>
            <input className="input" type="text" value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="ישיבת..." required />
          </div>
          <div className="form-group">
            <label className="label"><Mail size={14} /> כתובת מייל</label>
            <input className="input" type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="info@mosad.co.il" required />
          </div>
          <div className="form-group">
            <label className="label"><Lock size={14} /> סיסמה</label>
            <input className="input" type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} placeholder="לפחות 8 תווים" minLength={8} required />
          </div>
          <button className="btn btn-primary btn-full" type="submit" disabled={loading}>
            {loading ? 'נרשם...' : 'הרשמה'}
          </button>
        </form>
        <p className="auth-link">יש לך חשבון? <Link to="/login">התחברות</Link></p>
      </div>
    </div>
  );
}
